import React from "react";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Modal,
  Typography,
} from "@material-ui/core";

import CloseIcon from "@material-ui/icons/Close";

import { Alert } from "@material-ui/lab";

import { useModalStyles } from "../../modals/modalStyles";

export type BulkOperationConfirmationModalProps = {
  actionVerb: "edit tags" | "edit destinations";
  selectedEventIDs: string[];
  onClose: () => void;
  onConfirm: () => void;
};

function BulkOperationConfirmationModal({
  actionVerb,
  selectedEventIDs,
  onClose,
  onConfirm,
}: BulkOperationConfirmationModalProps) {
  const classes = useModalStyles();

  return (
    <Modal open={true} onClose={() => {}}>
      <Card className={classes.root}>
        <CardHeader
          classes={{ action: classes.closeIconAction }}
          title={`Are you sure you want to ${actionVerb} for ${selectedEventIDs.length} events?`}
          action={<CloseIcon onClick={onClose} />}
        />

        <Divider />

        <CardContent>
          <Grid container spacing={2}>
            <Grid item>
              <Alert severity="warning">
                <Typography variant="body1">
                  Are you sure you want to <strong>{actionVerb}</strong> for{" "}
                  <strong>{selectedEventIDs.length}</strong> events? This action
                  cannot be undone.
                </Typography>
              </Alert>
            </Grid>
          </Grid>
        </CardContent>

        <Divider />

        <CardActions className={classes.actions}>
          <Button onClick={() => onClose()}>Cancel</Button>

          <Button
            onClick={() => onConfirm()}
            variant="contained"
            color="primary"
          >
            {actionVerb}
          </Button>
        </CardActions>
      </Card>
    </Modal>
  );
}

export default BulkOperationConfirmationModal;
